// 📄 components/StepPOOutput.tsx
import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { PurchaseOrderFormData } from '../../../../../services/commerce/integrationService';

interface StepPOOutputProps {
  outputType: string;
  transmissionMedium: string;
  dispatchTime: string;
  onChange: (field: keyof PurchaseOrderFormData, value: any) => void;
}

export function StepPOOutput({ outputType, transmissionMedium, dispatchTime, onChange }: StepPOOutputProps) {
  return (
    <div className="space-y-4 animate-fadeIn">
      {/* SPRO Route */}
      <div className="bg-blue-500/5 border border-blue-500/10 rounded-xl p-3 mb-2 space-y-1">
        <span className="text-[10px] font-bold text-blue-400 uppercase tracking-widest block">Ruta SPRO / Transacción SAP</span>
        <p className="font-mono text-xs text-gray-300">
          <span className="bg-zinc-800 px-1.5 py-0.5 rounded text-gray-400 font-bold mr-1.5">NACE / VV21</span> 
          <span>SPRO → Integration with Other SAP Components → SAP Ariba Cloud Integration Gateway → Application-Specific Settings → Purchase Order → Output Determination</span>
        </p>
      </div>

      <div>
        <h3 className="text-lg font-medium text-blue-400">1. Output Determination (Determinación de Mensajes)</h3>
        <p className="text-sm text-gray-400">
          Configura la clase de mensaje y el medio de transmisión para permitir que el sistema determine la salida automática de la orden de compra.
        </p>
      </div>

      <div className="bg-white/5 p-4 rounded-xl border border-white/5 grid grid-cols-1 md:grid-cols-3 gap-4">
        <div>
          <label className="block text-xs font-medium text-gray-400 mb-1">Clase de Mensaje (Output Type)</label>
          <input
            type="text"
            value={outputType}
            onChange={(e) => onChange('outputType', e.target.value.toUpperCase())}
            placeholder="ej. NEU o ZNEU"
            maxLength={4}
            className="w-full bg-zinc-800 border border-white/10 rounded-lg p-2.5 text-sm font-mono text-white focus:outline-none focus:border-blue-500"
          />
        </div>

        <div>
          <label className="block text-xs font-medium text-gray-400 mb-1">Medio de Transmisión</label>
          <select
            value={transmissionMedium}
            onChange={(e) => onChange('transmissionMedium', e.target.value)}
            className="w-full bg-zinc-800 border border-white/10 rounded-lg p-2.5 text-sm text-white focus:outline-none focus:border-blue-500"
          >
            <option value="6">6 - EDI (Electronic Data Interchange)</option>
            <option value="1">1 - Print output (Impresión local)</option>
            <option value="2">2 - Fax</option>
            <option value="5">5 - External send (E-mail)</option>
          </select>
        </div>

        <div>
          <label className="block text-xs font-medium text-gray-400 mb-1">Momento de Envío (Dispatch Time)</label>
          <select
            value={dispatchTime}
            onChange={(e) => onChange('dispatchTime', e.target.value)}
            className="w-full bg-zinc-800 border border-white/10 rounded-lg p-2.5 text-sm text-white focus:outline-none focus:border-blue-500"
          >
            <option value="4">4 - Send immediately (upon saving)</option>
            <option value="1">1 - Send with periodic job (RSNAST00)</option>
            <option value="3">3 - Send with application own transaction</option>
          </select>
        </div>
      </div>

      <div className="bg-yellow-500/10 border border-yellow-500/20 rounded-xl p-4 text-yellow-400 flex gap-3 text-sm">
        <AlertTriangle className="w-5 h-5 flex-shrink-0" />
        <div>
          <p className="font-semibold">Importante: Esquemas de Cálculo y Clases de Documento</p>
          <p className="text-xs text-yellow-500/80 mt-0.5">
            Asegúrate de que la clase de mensaje definida esté correctamente asignada a tu esquema de mensajes de compra (generalmente <code className="bg-black/30 px-1 rounded">RMBEF1</code>) en la transacción <code className="bg-black/30 px-1 rounded">NACE</code>.
          </p>
        </div>
      </div>
    </div>
  );
}
